
import React from 'react';
import { StaffSidebar } from "./app-sidebar/StaffSidebar";
import { PatientSidebar } from "./app-sidebar/PatientSidebar";
import { useAuth } from "@/context/AuthContext";

const AppSidebar = () => {
  const { user, isLoading } = useAuth();
  
  console.log("AppSidebar - Rendering, user:", user?.name, "userType:", user?.userType, "isLoading:", isLoading);
  
  // Don't render anything while loading to prevent flashes
  if (isLoading) {
    console.log("AppSidebar - Loading user data...");
    return null;
  }
  
  // Don't render sidebar for non-authenticated users
  if (!user) {
    console.log("AppSidebar - No user found, not rendering sidebar");
    return null;
  }

  // For safety, check that userType is defined
  if (!user.userType) {
    console.error("AppSidebar - User has no userType defined:", user);
    return null;
  }

  // Show patient sidebar for patient users
  if (user.userType === 'patient') {
    console.log("AppSidebar - Rendering PatientSidebar for patient user");
    return <PatientSidebar />;
  }

  // For non-patient users, show the staff sidebar
  console.log("AppSidebar - Rendering StaffSidebar for", user.userType, "user");
  return <StaffSidebar isAdmin={user.isAdmin || false} />;
};

export default AppSidebar;
